import routerOptions0 from "/opt/mc/app/app/router.options.ts";
import routerOptions1 from "/opt/mc/app/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions1,
...routerOptions0,
}